/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SiteInfoDetail.vue?vue&type=template&id=95e1b9c6&scoped=true&"
import script from "./SiteInfoDetail.vue?vue&type=script&lang=js&"
export * from "./SiteInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./SiteInfoDetail.vue?vue&type=style&index=0&id=95e1b9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e1b9c6",
  null
  
)

export default component.exports